import React from "react";
import { Props_SnippetLongFormIconContent } from "./LongFormIconContent.props";
import SharedHeading from "../Shared/Heading/Heading";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import SnippetLink from '../Shared/Link/Link';

const SnippetLongFormIconContent = (
  props: Props_SnippetLongFormIconContent
) => {
  const { heading, repeatable_rows } = props;

  // Ensure correct types for heading props
  const headingLevel =
    (heading.level?.value as "h1" | "h2" | "h3" | "h4" | "h5" | "h6") || "h2";
  const headingAlignment =
    (heading.alignment?.value as "start" | "center" | "end") || undefined;
  const headingVisibility =
    typeof heading.visibility?.value === "boolean"
      ? heading.visibility.value
      : heading.visibility?.value === "true";

  return (
    <section className="snippet-longform-icon-content">
      <div className="snippet-longform-icon-content__container">
        <SharedHeading
          level={headingLevel}
          alignment={headingAlignment}
          visibility={headingVisibility}
          className="snippet-longform-icon-content__heading"
        >
          {heading.content?.value}
        </SharedHeading>
        <div className="snippet-longform-icon-content__rows">
          {repeatable_rows?.map((row, idx) => {
            const { icon, title, content, linkText, linkHref, linkStyle, linkTarget } = row;
            return (
              <div className="snippet-longform-icon-content__row" key={idx}>
                <div className="snippet-longform-icon-content__icon">
                  {icon?.value && (
                    <img
                      src={icon.value}
                      alt=""
                      loading="lazy"
                      className="snippet-longform-icon-content__icon-image"
                    />
                  )}
                </div>
                <div className="snippet-longform-icon-content__content">
                  {title?.value && (
                    <h3 className="snippet-longform-icon-content__row-heading">
                      {title.value}
                    </h3>
                  )}
                  {content?.value && (
                    <div className="snippet-longform-icon-content__text">
                      {CompileMarkdown(content.value)}
                    </div>
                  )}
                  { (
                    <SnippetLink
                      url={linkHref?.value}
                      linkStyles={linkStyle?.value || 'primary'}
                      openInNewTab={!!linkTarget?.value}
                    >
                      {linkText?.value}
                    </SnippetLink>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SnippetLongFormIconContent;
